import React from 'react';
import { Button } from 'antd';
import { FinanceLogo } from 'IMAGE';
import './_activateMagmaCard.less';
import PropTypes from 'prop-types';

const ActivateMagmaCard = ({ activateAccess, firstLoginMagma }) => {
  const handleClick = () => {
    activateAccess('magma');
  };

  return (
    <div className='card-dashboard-magma'>
      <div className='card-dashboard-magma__content'>
        <div className='title'>
          <FinanceLogo /> <div className='text'>MAGMA</div>
        </div>
        <div className='subtitle'>MULTI-CURRENCY ACCOUNT FOR CROSS BORDER PAYMENTS</div>
        <div className='description'>Receive, send funds, and convert over 100 currencies</div>
        <Button htmlType='submit' type={'dashed'} size={'large'} onClick={handleClick} block>
          {firstLoginMagma ? 'Activate access' : 'Re-Login'}
        </Button>
      </div>
    </div>
  );
};

export default ActivateMagmaCard;

ActivateMagmaCard.propTypes = {
  activateAccess: PropTypes.func.isRequired,
};
